import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setWorkflowImageAppSetting } from "../../../store/one-query/workflowsSlice";
import { useImageSuiteGetImageSettings } from "../../../store/Apis/SuitesApps/ImageSuitesApi";
import EditPinIcon from "../../../Custom-imeges/EditPinIcon";
import { workflowItem } from "../../../Types/Workflow-Types";
import WorkflowSelectedSteps from "./WorkflowSelectedSteps";
import WorkflowBody from "./WorkflowBody";

const WorkflowContainer = () => {
  const dispatch = useAppDispatch();
  const [workflowName, setWorkflowName] = useState<string>("Untitled");
  const [selectedItemData, setSelectedItemData] = useState<workflowItem>({
    appType: "",
    selectedFromDropdownItem: "",
    selectedToDropdownItem: "",
    sliderValue: 1,
    appOrder: 0,
    inputType: "",
    outputType: "",
    suiteType: 1,
    videoSettings:{
      selectedSize: "",
      selectedModel: {
        name: "",
        version: ""
      },
      selectedMode: "",
      selectedDuration: "",
      selectedStyle: { description: "", value: "" },
      seed: null,
      generateTime: "",
      creditsNeeded: 0
    }
  });
  const [workflowDetails, setWorkflowDetails] = useState<workflowItem[]>([]);
  const [isNewStep, setIsNewStep] = useState<boolean>(false);
  const errorWorkflowNameAlreadyExists = useAppSelector(
    (s) => s.ChatsState.fileErrorMsg.errorMsg
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const { refetch: GetImageSettings, data: ImageSettingsData } =
    useImageSuiteGetImageSettings();

  useEffect(() => {
    if (
      errorWorkflowNameAlreadyExists ===
        "Workflow already exists. Please enter a new name." ||
      errorWorkflowNameAlreadyExists ===
        "Cannot save: Workflow name is required."
    )
      handleIconClick();
  }, [errorWorkflowNameAlreadyExists]);

  useEffect(() => {
    GetImageSettings();
  }, []);

  useEffect(() => {
    if (ImageSettingsData) {
      dispatch(setWorkflowImageAppSetting(ImageSettingsData));
    }
  }, [ImageSettingsData]);

  const handleWorkflowName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWorkflowName(event.target.value);
  };

  const handleIconClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  };

  const handleNewStep = () => {
    setIsNewStep(true);
    setSelectedItemData({
      appType: "",
      selectedFromDropdownItem: "",
      selectedToDropdownItem: "",
      sliderValue: 1,
      appOrder: 0,
      suiteType:0
    });
  };
  return (
    <div className="create-workflow-view flex-grow-1">
      <div className="create-workflow-container">
        <div className="create-workflow-content">
          {/* workflow name  */}
          <span className="w-100 d-flex justify-content-center align-items-center position-relative">
            <input
              ref={inputRef}
              type="text"
              value={workflowName}
              onChange={handleWorkflowName}
              onClick={handleIconClick}
              className="workflowName"
            />
            <span
              style={{ position: "absolute" }}
              className="workflow-name-iconEdit"
              onClick={handleIconClick}
            >
              <EditPinIcon className="custom-icon" />
            </span>
          </span>
          {/* selected steps */}
          <WorkflowSelectedSteps
            workflowDetails={workflowDetails}
            setSelectedItemData={setSelectedItemData}
            handleNewStep={handleNewStep}
            selectedItemData={selectedItemData}
          />
          {/* workflow body */}
          <WorkflowBody
            workflowName={workflowName}
            setWorkflowName={setWorkflowName}
            isNewStep={isNewStep}
            workflowDetails={workflowDetails}
            selectedItemData={selectedItemData}
            setWorkflowDetails={setWorkflowDetails}
            setSelectedItemData={setSelectedItemData}
            setIsNewStep={setIsNewStep}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowContainer;
